import { Autocomplete, Box, Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";

function AirportSearchField(props) {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [searchValue, setSearchValue] = useState(null);

    useEffect(() => {
        let active = true;
        
        (async () => {
            const keyword = searchValue || '';
            const response = await fetch(`/api/custom/airports?keyword=${encodeURIComponent(keyword)}&t=${Date.now()}`);
            const airports = await response.json();
            
            if (active) {
                // ABC sorrend szerint rendezés reptérkód alapján
                const sortedAirports = (airports || []).sort((a, b) => {
                    if (!a.code || !b.code) return 0;
                    return a.code.localeCompare(b.code, 'hu', { sensitivity: 'base' });
                });
                setOptions(sortedAirports);
            }
        })();

        return () => {
            active = false;
        };
    }, [searchValue]);

    useEffect(() => {
        if (!open) {
            (async () => {
                const response = await fetch(`/api/custom/airports?keyword=&t=${Date.now()}`);
                const airports = await response.json();
                
                // ABC sorrend szerint rendezés reptérkód alapján
                const sortedAirports = (airports || []).sort((a, b) => {
                    if (!a.code || !b.code) return 0;
                    return a.code.localeCompare(b.code, 'hu', { sensitivity: 'base' });
                });
                setOptions(sortedAirports);
            })();
        }
    }, [open]);

    return (
        <Autocomplete
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            getOptionLabel={(option) => option ? `${option.code} ${option.name}` : ''}
            renderOption={(props, option) => (
                <Box component="li" {...props} sx={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ minWidth: '80px', fontWeight: 'bold', marginRight: '10px' }}>{option?.code}</span>
                    {option?.name}
                </Box>
            )}
            options={options}
            loading={!options}
            style={{ width: '100%' }}
            filterSelectedOptions={false}
            filterOptions={(options) => options}
            freeSolo={false}
            disablePortal={true}
            onChange={(event, newValue) => {
                props.onChange(newValue?.code, props.name)
            }}
            onInputChange={(event, newInputValue) => {
                setSearchValue(newInputValue || '');
            }}
            renderInput={(params) => <TextField
                {...params}
                label={props.label}
                onChange={props.onChange}
                fullWidth
                name={props.name}
                variant="standard" />}
        />
    );
}

export default AirportSearchField;
